import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { supabase, isSupabaseConfigured } from "@/lib/supabase";
import { WhatsAppIcon } from "@/components/Icons";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isSupabaseConfigured) return;
        supabase.auth.getSession().then(({ data }) => {
            if (data.session) navigate("/admin", { replace: true });
        });
    }, [navigate]);

    if (!isSupabaseConfigured) {
        return (
            <div
                data-testid="admin-login-unconfigured"
                className="grain flex min-h-screen items-center justify-center bg-ocean px-5 font-body text-ink"
            >
                <div className="w-full max-w-md rounded-3xl border border-neon-sun/40 bg-deep p-8 text-center">
                    <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.3em] text-neon-sun">
                        Área administrativa
                    </p>
                    <h1 className="mt-4 font-display text-2xl font-black uppercase">
                        Supabase não configurado
                    </h1>
                    <p className="mt-4 text-sm leading-relaxed text-dim">
                        Defina as variáveis de ambiente{" "}
                        <span className="font-mono2 text-neon-cyan">
                            REACT_APP_SUPABASE_URL
                        </span>{" "}
                        e{" "}
                        <span className="font-mono2 text-neon-cyan">
                            REACT_APP_SUPABASE_ANON_KEY
                        </span>{" "}
                        no frontend e siga o guia{" "}
                        <span className="font-mono2 text-neon-cyan">
                            supabase/INSTRUCOES-SUPABASE.md
                        </span>{" "}
                        para criar as tabelas e o primeiro administrador.
                    </p>
                    <a
                        href="/"
                        data-testid="admin-login-back-site"
                        className="mt-8 inline-flex rounded-full border border-ink/25 px-6 py-3 font-display text-[10px] font-extrabold uppercase tracking-widest text-ink transition-colors hover:border-neon-cyan hover:text-neon-cyan"
                    >
                        Voltar ao site
                    </a>
                </div>
            </div>
        );
    }

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });
        setLoading(false);
        if (error) {
            setErr("E-mail ou senha incorretos.");
            return;
        }
        navigate("/admin", { replace: true });
    };

    return (
        <div className="grain flex min-h-screen items-center justify-center bg-ocean px-5 font-body text-ink">
            <div className="w-full max-w-md rounded-3xl border border-neon-cyan/20 bg-deep p-8 sm:p-10">
                <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.3em] text-neon-cyan">
                    Jetski Paradise • Admin
                </p>
                <h1 className="mt-3 font-display text-3xl font-black uppercase leading-tight">
                    Acesso restrito
                </h1>
                <form onSubmit={submit} className="mt-8 space-y-5">
                    <label className="block">
                        <span className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.25em] text-neon-cyan">
                            E-mail
                        </span>
                        <input
                            type="email"
                            required
                            data-testid="admin-login-email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 w-full rounded-xl border border-ink/15 bg-ocean/60 px-4 py-3 text-sm text-ink focus:border-neon-cyan focus:outline-none"
                        />
                    </label>
                    <label className="block">
                        <span className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.25em] text-neon-cyan">
                            Senha
                        </span>
                        <input
                            type="password"
                            required
                            data-testid="admin-login-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 w-full rounded-xl border border-ink/15 bg-ocean/60 px-4 py-3 text-sm text-ink focus:border-neon-cyan focus:outline-none"
                        />
                    </label>
                    {err && (
                        <p
                            data-testid="admin-login-error"
                            className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-neon-coral"
                        >
                            {err}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="group inline-flex w-full items-center justify-center gap-3 rounded-full bg-neon-cyan px-7 py-4 font-display text-xs font-extrabold uppercase tracking-widest text-ocean transition-transform duration-300 hover:scale-[1.02] disabled:opacity-50"
                    >
                        {loading ? "Entrando..." : "Entrar"}
                        <WhatsAppIcon className="hidden h-4 w-4" />
                    </button>
                </form>
                <a
                    href="/"
                    data-testid="admin-login-back-site"
                    className="mt-6 inline-flex font-mono2 text-[10px] uppercase tracking-[0.25em] text-dim transition-colors hover:text-neon-cyan"
                >
                    ← Voltar ao site
                </a>
            </div>
        </div>
    );
}
